import React from 'react';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const topics = ['Fundamentos', 'Técnica corporal', 'Cuerda', 'Aro', 'Pelota', 'Mazas', 'Cinta', 'Coreografía', 'Planificación', 'Evaluación', 'Progresión', 'Seguimiento', 'Música', 'Seguridad', 'Gestión'];
const levels = ['Iniciación', 'Intermedio', 'Avanzado', 'Exhibición y Competencia', 'Planificación Anual', 'Academia y Gestión'];
export function ProductOverview() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-312">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-313">
        <div className="text-center mb-8 md:mb-16" data-id="element-314">
          <div className="inline-block bg-accent text-primary font-semibold px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm mb-4 md:mb-6 border border-primary-light" data-id="element-315">
            Sistema N°1 para Instructoras de Gimnasia Rítmica Infantil en
            Argentina
          </div>
          <h2 className="text-3xl md:text-5xl font-bold font-serif text-secondary-dark mb-2 md:mb-4" data-id="element-316">
            GIMNASIA RÍTMICA INFANTIL RESUELTA™
          </h2>
          <p className="text-lg md:text-2xl text-gray-600 font-medium" data-id="element-317">
            6 Tomos + 6 Bonos — Todos los niveles — Todo resuelto.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-6 mb-8 md:mb-16" data-id="element-318">
          <div className="bg-accent rounded-xl md:rounded-2xl p-4 md:p-8 text-center border border-primary-light/50" data-id="element-319">
            <div className="w-10 h-10 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4 shadow-sm text-primary" data-id="element-320">
              <BookOpen className="w-5 h-5 md:w-8 md:h-8" data-id="element-321" />
            </div>
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-0.5 md:mb-2" data-id="element-322">
              +600
            </h3>
            <p className="text-xs md:text-base text-gray-600 font-medium" data-id="element-323">
              páginas
            </p>
          </div>
          <div className="bg-accent rounded-xl md:rounded-2xl p-4 md:p-8 text-center border border-primary-light/50" data-id="element-324">
            <div className="w-10 h-10 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4 shadow-sm text-primary" data-id="element-325">
              <CheckCircle2 className="w-5 h-5 md:w-8 md:h-8" data-id="element-326" />
            </div>
            <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-0.5 md:mb-2" data-id="element-327">
              60+
            </h3>
            <p className="text-xs md:text-base text-gray-600 font-medium" data-id="element-328">
              clases listas
            </p>
          </div>
          <div className="bg-accent rounded-xl md:rounded-2xl p-4 md:p-8 text-center border border-primary-light/50" data-id="element-329">
            <div className="w-10 h-10 md:w-16 md:h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4 shadow-sm text-primary" data-id="element-330">
              <span className="text-xl md:text-3xl" data-id="element-331">🚀</span>
            </div>
            <h3 className="text-sm md:text-xl font-bold text-gray-900 mb-0.5 md:mb-2 leading-tight" data-id="element-332">
              Funciona hoy
            </h3>
            <p className="text-xs md:text-base text-gray-600 font-medium" data-id="element-333">
              en tu gimnasio
            </p>
          </div>
        </div>

        <div className="mb-8 md:mb-16" data-id="element-334">
          <h3 className="text-xl md:text-2xl font-bold font-serif text-center mb-4 md:mb-8 text-secondary-dark" data-id="element-335">
            Niveles y enfoques incluidos
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-336">
            {levels.map((level, i) => <span key={i} className="bg-secondary text-white px-3 py-1.5 md:px-5 md:py-2.5 rounded-full font-medium shadow-sm text-xs md:text-base" data-id="element-337">
                {level}
              </span>)}
          </div>
        </div>

        <div className="bg-gray-50 rounded-2xl md:rounded-3xl p-5 md:p-12 border border-gray-200" data-id="element-338">
          <h3 className="text-xl md:text-2xl font-bold font-serif text-center mb-4 md:mb-8 text-gray-900" data-id="element-339">
            Todo lo que vas a dominar
          </h3>
          <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-340">
            {topics.map((topic, i) => <span key={i} className="bg-white border border-gray-300 text-gray-700 px-3 py-1.5 md:px-4 md:py-2 rounded-lg font-medium shadow-sm text-xs md:text-base hover:border-primary hover:text-primary transition-colors cursor-default" data-id="element-341">
                {topic}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}